import React, {FC, JSX, useEffect, useRef, useState} from "react";
import cls from "./Wrappers/CustomHeader/customHeader.module.scss";
import {ArrowRoundedDown9x6Svg, DropMenusSVG} from "../../svg";
import CustomItemList from "./Wrappers/CustomHeader/CustomItemList";
import Link from "next/link";
import {domainUrl} from "../../helper";
import {IMenu} from "../../types/productPageTypes";

interface IProps {
    topMenus: IMenu[];
    domain: string;
    dbName: string;
    font_family: string;
    menusRowWidth: number;
}

const MenuRenderer:FC<IProps> = ({ topMenus, domain, dbName, font_family, menusRowWidth }) => {
    const [dropOpen, setDropOpen] = useState<boolean>(false);
    const dropDownRef = useRef<any>(null);
    const [openMenus, setOpenMenus] = useState<number[]>([]);
    const gap = 34;
    let menusWidth = 60;
    let isOverflow = false;
    const letterSizeObj = {
        "GT America Expanded": 12,
        "GT America Compressed": 6.5,
        "GT America Condensed": 8,
        "GT America Extended": 10,
        "GT America Mono": 9.5,
        "GT America Standard": 9
    }
    let letterSize:number = letterSizeObj[font_family as keyof typeof letterSizeObj] || 9; // average number of each letter
    const toggleSub = (id: number) => {
        if (openMenus.some(subId => subId === id)) {
            setOpenMenus((prevState) => prevState.filter(subId => subId !== id))
        } else {
            setOpenMenus(prevState => [...prevState, id])
        }
    }

    useEffect(() => {
        const handleClick = (e: MouseEvent) => {
            if (dropDownRef.current && !dropDownRef.current.contains(e.target as Node)) {
                setDropOpen(false);
            }
        }

        window.addEventListener("mousedown", handleClick)

        return () => window.removeEventListener("mousedown", handleClick)
    }, [dropDownRef])
    const toggleDrop = () => {
        setDropOpen(prevState => !prevState)
    }
    const renderMenus = () => {
        let visibleCollection: JSX.Element[] = [];
        let dropdownCollection: JSX.Element[] = [];

        topMenus.forEach((item: any, index: number) => {
            const {name = "", id, children = [], url_key = "", target} = item;
            const existThisMenuId = openMenus.some(elem => elem === id)

            let arrow = null;
            let menu = null;
            let menu2 = null;


            if (children.length) {
                arrow = <div className={`${cls.wrapper__bttn} ${existThisMenuId && cls.closed}`}>
                    <ArrowRoundedDown9x6Svg/>
                </div>
                menu = <CustomItemList items={children} openMenus={openMenus} toggleSub={toggleSub} dbName={dbName} domain={domain}/>

                menu2 = <div className={`${cls.deep__submenu} ${existThisMenuId && cls.opened__drop}`}>
                    <CustomItemList items={children} openMenus={openMenus} toggleSub={toggleSub} dbName={dbName} domain={domain}/>
                </div>
            }

            if (item && item.name) {
                const itemArrow =
                    (item.children?.length ? 15 : 0) +
                    (item.image ? 33 : 0);
                const itemWidth = item.name.length * letterSize + itemArrow + gap;

                const visibleItem = <div key={index} className={cls.header_nav_menu_item}>
                    <Link href={url_key} prefetch={true}>
                        <a {...target}>
                            <div className={cls["name-icon__container"]}>
                                {item.image ? <div className={cls.icon_wrapper}>
                                    <img
                                        width={25}
                                        height={25}
                                        alt="menu icon"
                                        src={domainUrl(`${dbName}/storage/${domain}/${item.image}`)}
                                    />
                                </div> : null}
                                {name}
                            </div>
                            {arrow}
                        </a>
                    </Link>
                    {menu}
                </div>

                const dropdownItem =
                    <div
                        key={index}
                        className={cls.header_nav_menu_item}
                        onClick={() => toggleSub(id as number)}
                    >
                        <div className={cls.menu_item__container}>
                            <button
                                className={`${cls.link__button} ${menu && cls.only__link}`}
                                onClick={e => e.stopPropagation()}
                            >
                                <Link href={url_key} prefetch={true}>
                                    <a
                                        {...target}
                                    >
                                        <div className={cls["name-icon__container"]}>
                                            {item.image ? <div className={cls.icon_wrapper}>
                                                <img
                                                    width={25}
                                                    height={25}
                                                    alt="menu icon"
                                                    src={domainUrl(`${dbName}/storage/${domain}/${item.image}`)}
                                                    loading="lazy"
                                                />
                                            </div> : null}
                                            {name}
                                        </div>
                                    </a>
                                </Link>
                            </button>
                            {arrow}
                        </div>
                        {menu2}
                    </div>
                if (isOverflow || menusWidth + itemWidth > menusRowWidth) {
                    isOverflow = true;
                    dropdownCollection.push(dropdownItem);
                } else {
                    menusWidth += itemWidth;
                    visibleCollection.push(visibleItem);
                }
            }
        })

        return (
            <>
                {visibleCollection}
                {!!dropdownCollection.length &&
                    <div ref={dropDownRef} className={cls.dropMenus__container}>
                        <button
                            className={cls.wrapper__bttn}
                            onClick={toggleDrop}>
                            <DropMenusSVG/>
                        </button>
                        <div className={`${cls.dropMenus__body} ${dropOpen ? cls.opened__drop : null}`}>
                            {dropdownCollection}
                        </div>
                    </div>
                }
            </>
        )
    }
    return (
        <div className={`${cls.header} ${cls.top_header}  ${cls.renderer_header}`}>
            <div className={cls.second_section} style={{ height: "unset" }}>
                <div className={cls.header_nav_menu} style={{ width: "max-content" }}>
                    {renderMenus()}
                </div>
            </div>
        </div>
    )
}

export default MenuRenderer